<template>
  <div class="wb-sidebar-menu-item-counter">
    <SVGMinus @click="$emit('count-del');countNewCost()"/>
    <div class="wb-sidebar-menu-item-counter-value">{{ value }}</div>
    <SVGPlus @click="$emit('count-add');countNewCost()"/>
  </div>
</template>

<script>
import SVGPlus from '@/UI/Components/SVG/SVGPlus.vue';
import SVGMinus from '@/UI/Components/SVG/SVGMinus.vue';
import { computeCost } from '@/lib/computeCost';
import { useConfigurationStore } from '@/Store/storeConfiguration';
import { useStoreData } from '@/Store/storeData';

export default {
    name: 'SidebarMenuItemCounter',
    components: {
        SVGMinus,
        SVGPlus,
    },
    props: [
        'value',
    ],
  setup() {
    const storeData = useStoreData();
    const storeConfiguration = useConfigurationStore();
    return {
      storeData,
      storeConfiguration,
    };
  },
  methods:{
      countNewCost(){
        let itemIDs = this.storeConfiguration.getAllItemIDs;
        let items = this.storeData.getItemsByIdArr(itemIDs);
        const counts = {};
        itemIDs.forEach((x) => { counts[x] = (counts[x] || 0) + 1; });

        for (let item of items) {
          item.count = counts[item.id];
        }
        this.storeData.setCost(computeCost(items));
        this.storeData.setZeroPrice(items.some(item=>item.price!=0));
        this.storeData.countItems = items.length;
      },
  },
};
</script>

<style scoped lang="scss">
@import "CSS/colors.scss";
@import "CSS/fonts.scss";

.wb-sidebar-menu-item-counter {
    color: $gray3;
    @include font-t1;
    padding: 12px;
    height: 40px;
    border-radius: 30px;
    border: 1px solid var(--gray-400, #9C9C9C);
    display: grid;
    grid-auto-flow: column dense;
    grid-column-gap: 12px;
    align-items: center;
    box-sizing: border-box;
}

.wb-sidebar-menu-item-counter-value {
  color: var(--black, #2D3843);
  text-align: center;
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
</style>
